export const tabKeyCode = 9;
export const enterKeyCode = 13;
export const upKeyCode = 38;
export const downKeyCode = 40;
